import React from 'react';
import { View } from 'react-native';

export interface ContainerProps {
  children: React.ReactNode;
  additionalContent?: React.ReactNode;
}

const Container: React.FC<ContainerProps> = ({
  children,
  additionalContent,
}) => {
  return (
    <>
      <View className="flex-row items-center justify-between">{children}</View>
      {additionalContent}
    </>
  );
};

export default Container;
